import calendar from 'js-calendar-converter'

var date = {
  // 农历月份
  nlMonth: ["正", "二", "三", "四", "五", "六", "七", "八", "九", "十", "冬", "腊"],
  // 农历天份 29
  nlDay1: ["初一", "初二", "初三", "初四", "初五", "初六", "初七", "初八", "初九", "初十", "十一", "十二", "十三", "十四", "十五", "十六", "十七", "十八", "十九", "二十", "廿一", "廿二", "廿三", "廿四", "廿五", "廿六", "廿七", "廿八", "廿九"],
  // 农历天份 30
  nlDay2: ["初一", "初二", "初三", "初四", "初五", "初六", "初七", "初八", "初九", "初十", "十一", "十二", "十三", "十四", "十五", "十六", "十七", "十八", "十九", "二十", "廿一", "廿二", "廿三", "廿四", "廿五", "廿六", "廿七", "廿八", "廿九", "三十"],

  years(){
    var glYear = []
    for (let i = 1900; i <= new Date().getFullYear() + 5; i++) {
        glYear.push(i)
    }
    return glYear
  },
  // 公历份
  glMonths(){
    var glMonth = []
    for (let i = 1; i <= 12; i++) {
        glMonth.push(i < 10 ? ('0' + i) : i)
    }
    return glMonth
  },

  // 公历天份 28天
  glDay28(){
    var glDay28 = []
    for (let i = 1; i <= 28; i++) {
        glDay28.push(i < 10 ? ('0' + i) : i)
    }
    return glDay28
  },
  glDay29(){
    var glDay29 = []
    for (let i = 1; i <= 29; i++) {
        glDay29.push(i < 10 ? ('0' + i) : i)
    }
    return glDay29
  },
  glDay30(){
    var glDay30 = []
    for (let i = 1; i <= 30; i++) {
        glDay30.push(i < 10 ? ('0' + i) : i)
    }
    return glDay30
  },
  glDay31(){
    var glDay31 = []
    for (let i = 1; i <= 31; i++) {
        glDay31.push(i < 10 ? ('0' + i) : i)
    }
    return glDay31
  },
  //获取农历月份数组
  nlMonths(y){
    let nlMonths = Array.from(this.nlMonth)
    //第几个月是闰月，0为没有
    var leapMonthIndex = calendar.leapMonth(y)
    var leapMonthName = ''
    //有闰月
    if(leapMonthIndex > 0){
      //闰月的天数
      // var leapMonthCount = calendar.leapDays(y)
      switch(leapMonthIndex){
        case 1:
          leapMonthName = '闰正';
          break;
        case 2:
          leapMonthName = '闰二';
          break;
        case 3:
          leapMonthName = '闰三';
          break;
        case 4:
          leapMonthName = '闰四';
          break;
        case 5:
          leapMonthName = '闰五';
          break;
        case 6:
          leapMonthName = '闰六';
          break;
        case 7:
          leapMonthName = '闰七';
          break;
        case 8:
          leapMonthName = '闰八';
          break;
        case 9:
          leapMonthName = '闰九';
          break;
        case 10:
          leapMonthName = '闰十';
          break;
        case 11:
          leapMonthName = '闰冬';
          break;
        case 12:
          leapMonthName = '闰腊';
          break;
      }
      nlMonths.splice(leapMonthIndex,0,leapMonthName)
    }
    return nlMonths;
  },
  //获取农历天数数组
  nlDays(y,month,isLeap){
    var m = parseInt(month)
    var monthCount = 0
    if(isLeap){
      monthCount = calendar.leapDays(y)
    }else{
      monthCount = calendar.monthDays(y,m)
    }
    return monthCount == 29?this.nlDay1:this.nlDay2
  },
  glDays(year,m) {
    var month = parseInt(m)
    if (month == 1 || month == 3 || month == 5 || month == 7 || month == 8 || month == 10 || month == 12)
        return this.glDay31()
    else if (month != 2)
        return this.glDay30()
    else {
        var days = this.glDay28();
        // 判断闰年
        if ((year % 4 == 0 && year % 100 != 0) || year % 400 == 0) {
            days = this.glDay29();
        }
        return days;
    }
  },
  convertLunarDayToNumeric(lunarDateString) {
  // 如果输入的字符串包含"初"，则取其后面的数字，并在前面补零
  if (lunarDateString.startsWith('初')) {
      // 获取“初”之后的字符，例如从“初一”中获取“一”
      const digitAfterChu = lunarDateString.substring(1);

      // 根据汉字转换为数字
      let numericValue = '';
      switch (digitAfterChu) {
          case '一':
              numericValue = '01';
              break;
          case '二':
              numericValue = '02';
              break;
          case '三':
              numericValue = '03';
              break;
          case '四':
              numericValue = '04';
              break;
          case '五':
              numericValue = '05';
              break;
          case '六':
              numericValue = '06';
              break;
          case '七':
              numericValue = '07';
              break;
          case '八':
              numericValue = '08';
              break;
          case '九':
              numericValue = '09';
							break;
					case '十':
              numericValue = '10';
              break;
          default:
              console.error('Invalid character after "初": ' + digitAfterChu);
              return null;
      }
      return numericValue;
  }else if (lunarDateString.length === 2) {  // 如果输入的字符串是两位数的汉字，直接转换
      const firstChar = lunarDateString[0];
      const secondChar = lunarDateString[1];
      let numericValue = '';

      switch (firstChar) {
          case '十':
              numericValue = '1';
              break;
          case '廿':
              numericValue = '2';
							break;
					case '二':
              numericValue = '2';
              break;
          case '卅':
              numericValue = '3';
							break;
					case '三':
              numericValue = '3';
              break;
          default:
              console.error('Invalid first character: ' + firstChar);
              return null;
      }

      switch (secondChar) {
          case '一':
              numericValue += '1';
              break;
          case '二':
              numericValue += '2';
              break;
          case '三':
              numericValue += '3';
              break;
          case '四':
              numericValue += '4';
              break;
          case '五':
              numericValue += '5';
              break;
          case '六':
              numericValue += '6';
              break;
          case '七':
              numericValue += '7';
              break;
          case '八':
              numericValue += '8';
              break;
          case '九':
              numericValue += '9';
              break;
          case '十':
              numericValue += '0';
              break;
          default:
              console.error('Invalid second character: ' + secondChar);
              return null;
      }
      return numericValue;
    } else {
        console.error('Invalid lunar date string');
        return null;
    }
  },
  convertLunarMonthToNumeric(lunarMonthString){
    var newMonth = lunarMonthString
    console.log(8888,newMonth);
    if(lunarMonthString.indexOf('闰') >= 0){
      newMonth = lunarMonthString.replace('闰', "")
    }
    if(lunarMonthString.indexOf('月')){
      newMonth = newMonth.replace('月','')
    }
    // 定义一个对象来映射汉字份到数字
    const monthMap = {
      '正': '01',
      '二': '02',
      '三': '03',
      '四': '04',
      '五': '05',
      '六': '06',
      '七': '07',
      '八': '08',
      '九': '09',
      '十': '10',
      '冬': '11',
      '腊': '12'
    };
    // 检查输入的字符串是否在映射对象中
    if (monthMap.hasOwnProperty(newMonth)) {
        return monthMap[newMonth];
    } else {
        console.error('Invalid lunar month string');
        return null;
    }
  }
}

export default date
